import { useWeb3Modal } from '@web3modal/wagmi/vue';

export function dologin() {
  const { open } = useWeb3Modal();
  open();
}
